/**
 * 검색창에 보여줄 placeholder 문구를 생성하는 함수
 * B/F 모두 사용 가능한 유틸성 함수인데 일단 ServiceB 에 위치시킴
 */
export const getSearchInputPlaceholder = (lang: 'kr' | 'en' | 'jp'): string => {
  const event_placeholder: Readonly<Record<typeof lang, string>> = {
    kr: '마플샵 리뉴얼 기념 BLUEWEEK 5% OFF',
    en: 'Renewal BLUEWEEK 5% OFF',
    jp: 'リニューアル BLUEWEEK 5% OFF',
  };

  const default_placeholder: Readonly<Record<'kr' | 'en' | 'jp', string>> = {
    kr: '마플샵에서 찾아보는 나만의 취향!',
    en: 'Find your Tasty in MarppleShop',
    jp: 'MarppleShopで探す私の好み！',
  };

  const date_0613_1830 = 1718271000000; // 2024-06-13T18:30:00+09:00
  const date_0630_2359 = 1719759599000; // 2024-06-30T23:59:59+09:00

  const now = Date.now();
  if (now >= date_0613_1830 && now <= date_0630_2359) {
    return event_placeholder[lang];
  }
  return default_placeholder[lang];
};
